import JoySelect, { selectClasses } from '@mui/joy/Select';
import { KeyboardArrowDown } from '@mui/icons-material';
import Option from '@mui/joy/Option';
import { SimpleOption } from '../../types';
import { SxProps } from '@mui/system';
import { FocusEvent, KeyboardEvent, MouseEvent } from 'react';

interface SelectProp {
	options: SimpleOption[];
	value: string | null;
	onChange?: (value: string | null) => void;
	width: string;
	showId?: boolean;
	print?: boolean;
	label: string;
}

export default function Select({
	value,
	options = [],
	onChange = (value) => console.log(value),
	width,
	showId = false,
	print = false,
	label
}: //placeholder = 'Select a State'
SelectProp) {
	const SELECT_SX: SxProps = {
		[`& .${selectClasses.indicator}`]: {
			transition: '0.4s',
			[`&.${selectClasses.expanded}`]: {
				transform: 'rotate(-180deg)'
			}
		},
		borderRadius: '0px',
		borderTop: 'none',
		borderRight: 'none',
		borderLeft: 'none',
		borderBottom: '3px solid black',
		paddingInline: '0px',
		fontSize: '22px',
		boxShadow: 'none',
		backgroundColor: 'transparent',
		[`& .MuiSelect-button`]: {
			fontWeight: 700,
			margin: 0,
			paddingBottom: print ? '.75rem' : '0'
		},
		[`& .MuiSvgIcon-root`]: {
			fontSize: '32px',
			fill: 'black'
		}
	};

	function handleOnChange(
		_event:
			| MouseEvent<Element, globalThis.MouseEvent>
			| KeyboardEvent<Element>
			| FocusEvent<Element, Element>
			| null,
		value: string | null
	) {
		onChange(value);
	}

	return (
		<div>
			<JoySelect
				//placeholder={placeholder}
				sx={{ ...SELECT_SX, width: width }}
				indicator={<KeyboardArrowDown />}
				onChange={(e, v) => handleOnChange(e, v)}
				value={value}
				aria-label={label}
				variant='plain'
			>
				{options.map(({ id, label, disabled }) => (
					<Option key={id} value={id} disabled={disabled}>
						{showId ? id.toUpperCase() : label}
					</Option>
				))}
			</JoySelect>
		</div>
	);
}
